import { render, staticRenderFns } from "./SelectField.vue?vue&type=template&id=6c038325&"
import script from "./SelectField.vue?vue&type=script&lang=js&"
export * from "./SelectField.vue?vue&type=script&lang=js&"
import style0 from "./SelectField.vue?vue&type=style&index=0&id=6c038325&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseInputField: require('/vercel/path0/components/ui/forms/BaseInputField.vue').default})
